import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { DocumentResourceService } from '../../shared/services/document-resource.service'
import { columnPipe, rowPipe, searchPipe } from './pipes/data-filter.pipe';
import { DocumentRoutingModule } from './document-routing.module';
import { DocumentComponent } from './components/document.component';
import { PaginationModule } from 'ngx-bootstrap/pagination';
import { CategoryPipe } from './pipes/search-filter.pipe';
import { OrderrByPipe } from './pipes/order-filter.pipe';
import { BsModalModule } from 'ng2-bs3-modal';
import { PrincipalService } from '../../shared';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    DocumentRoutingModule,
    PaginationModule.forRoot(),
    TranslateModule.forChild(),
    BsModalModule
  ],
  exports: [FormsModule, ReactiveFormsModule],
  declarations: [DocumentComponent, columnPipe, rowPipe, searchPipe, CategoryPipe, OrderrByPipe],
  providers: [DocumentResourceService, PrincipalService]
})
export class DocumentModule {
}
